/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step3_NameInputs */

const en_dr_step3_name = /** @type {(inputs: Dr_Step3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 · Assumptions & hypotheses`)
};

const id_dr_step3_name = /** @type {(inputs: Dr_Step3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 · Asumsi & hipotesis`)
};

/**
* | output |
* | --- |
* | "3 · Assumptions & hypotheses" |
*
* @param {Dr_Step3_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step3_name = /** @type {((inputs?: Dr_Step3_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step3_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step3_name(inputs)
	return en_dr_step3_name(inputs)
});